export default __webpack_public_path__ + "static/media/emoji_smile.5b1f59ba.png";